import { Caption, Card, Cell, Image, List, Progress, Section } from '@telegram-apps/telegram-ui';
import { useNavigate } from 'react-router-dom';
import { ErrorState, LoadingState } from '../components/StateViews';
import { useDashboard } from '../hooks/useDashboard';
import { useMe } from '../hooks/useMe';

const PLAN_LABELS: Record<string, string> = {
  free: 'Free',
  trial: 'Trial (legacy)',
  start: 'Start',
  growth: 'Growth',
  pro: 'Pro (legacy)',
  scale: 'Scale',
};

export function DashboardPage() {
  const navigate = useNavigate();
  const me = useMe();
  const dash = useDashboard();

  if (me.isLoading || dash.isLoading) return <LoadingState />;
  if (me.error) return <ErrorState error={me.error as Error} onRetry={() => void me.refetch()} />;
  if (dash.error)
    return <ErrorState error={dash.error as Error} onRetry={() => void dash.refetch()} />;

  const shop = me.data?.shop;
  const subscription = me.data?.subscription;
  const d = dash.data;

  if (!shop || !d) {
    return <ErrorState error={new Error('shop_not_found')} />;
  }

  const planLabel = subscription?.plan ? PLAN_LABELS[subscription.plan] ?? subscription.plan : 'Free';

  return (
    <List>
      <Section header="Бутик">
        <Cell subtitle={shop.contact ?? 'контакт не указан'}>{shop.name}</Cell>
        <Cell subtitle="Тариф">{planLabel}</Cell>
      </Section>

      <Section header="Лимит примерок">
        <Cell subtitle={`${d.usage.used} из ${d.usage.limit}`}>{d.usage.percent}%</Cell>
        <Progress value={d.usage.percent} />
        <Cell subtitle="Сегодня">{d.usage.today} использовано</Cell>
        <Cell subtitle="Товаров в каталоге">{d.productsCount.total}</Cell>
      </Section>

      <Section header="Последние генерации">
        {d.recentGenerations.length === 0 ? (
          <Caption level="1">Пока нет завершённых генераций</Caption>
        ) : (
          d.recentGenerations.map((g) => (
            <Card key={g.id}>
              <Cell subtitle={g.type}>
                {g.thumbnail ? (
                  <Image src={g.thumbnail} alt={g.id} />
                ) : (
                  <Caption level="1">нет превью</Caption>
                )}
              </Cell>
            </Card>
          ))
        )}
      </Section>

      <Section header="Управление">
        <Cell onClick={() => navigate('/settings')}>⚙️ Настройки</Cell>
        <Cell onClick={() => navigate('/subscription')}>💳 Подписка</Cell>
      </Section>
    </List>
  );
}
